import { render, staticRenderFns } from "./Covering.vue?vue&type=template&id=14d98626&"
import script from "./Covering.vue?vue&type=script&lang=js&"
export * from "./Covering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports